import IApplicationState from 'app/types/state';
import { IClubsState, IClubsSelector } from 'app/ducks/clubs/types';
import _ from 'lodash';

import { getPaymentIdsByClubId } from 'app/ducks/payments/selectors';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.clubs.clubsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getClubsFilteredByTagInSelectFormat(
  state: IApplicationState,
  tagId,
): any {
  const { clubsById }: IClubsState = state.clubs;
  const clubs = _.filter(clubsById, { tags: [tagId] });
  const mappedClubs = _.map(clubs, (n) => mapSelect(state, n.id));
  return mappedClubs;
}

export function getClubsByIdInSelectFormat(state): any {
  const { clubIds } = state.clubs;
  const mappedClubs = _.map(clubIds, (n) => mapSelect(state, n));
  return mappedClubs;
}

export function getTeamMemberIds(state, clubId): any {
  if (state.clubs.clubsById !== undefined && clubId !== undefined) {
    return state.clubs.clubsById[clubId].teamMembers;
  }
  return [];
}

export const getPaymentCollectionIds = (state, clubId): any => {
  getPaymentCollectionIdsByClubId(state, clubId);
};

export function getPaymentIds(state, clubId): any {
  return getPaymentIdsByClubId(state, clubId);
}

export function getCurrentClub(state): any {
  if (
    state.clubs !== undefined
    && state.clubs.clubsById !== undefined
    && state.clubs.currentClubId !== undefined
    && !_.isEmpty(state.clubs.clubsById[state.clubs.currentClubId])
  ) {
    const findClub = state.clubs.clubsById[state.clubs.currentClubId];
    const groupId = findClub.group !== undefined ? findClub.group.id : null;
    const currentClub = {
      ...findClub,
      // connectedToAssociation:
      //   findClub.group !== undefined && findClub.group.id !== null,
      // payments: getPaymentIds(state, state.clubs.currentClubId),
      // paymentCollections: getPaymentCollectionIds(
      //   state,
      //   state.clubs.currentClubId,
      // ),
      // organisation: {
      //   ...findClub.organisation,
      //   ...getOrganisationById(state, findClub.organisationId),
      // },
      // group: {
      //   ...findClub.group,
      //   ...getGroupById(state, groupId),
      // },
    };

    return currentClub;
  }
  return {};
}

export function getCurrentFormClub(state: IApplicationState) {
  return {
    ...getCurrentClub(state),
    ...state.clubs.requestedData,
  };
}

export function getClubs(state): IClubsSelector {
  return {
    ...state.clubs,
    currentClub: getCurrentClub(state),
    currentFormClub: getCurrentFormClub(state),
    clubsByIdInSelectFormat: getClubsByIdInSelectFormat(state),
    getClubsFilteredByTagInSelectFormat: (tagId): any => getClubsFilteredByTagInSelectFormat(state, tagId),
  };
}
